import React, { Component } from 'react';

class RouteElementContentSubTitle extends Component {
	render() {
		return <div className = 'route_element_content_subtitle'>
			{this.props.display}
		</div>;
	}
}

export default RouteElementContentSubTitle; 


// WEBPACK FOOTER //
// ./src/components/home/RouteElementContentSubTitle.jsx